import { z } from 'zod';
import { Option } from '../../types/Option';

const batteryTechnologyValues = [
    'li-ion',
    'lfp',
    'lto',
    'nimh',
    'nicd',
    'nizn',
    'lead-acid',
    'flow',
    'solid-state',
    'zinc-air',
    'sodium-ion',
    'sodium-sulfur',
    'lithium-sulfur',
] as const;

type BatteryTechnology = (typeof batteryTechnologyValues)[number];

const options: Option<BatteryTechnology>[] = [
    { value: 'lfp', label: 'Lithium Iron Phosphate' },
    { value: 'li-ion', label: 'Lithium Ion' },
    { value: 'lto', label: 'Lithium Titanate' },
    { value: 'nimh', label: 'Nickel Metal Hydride' },
    { value: 'nicd', label: 'Nickel Cadmium' },
    { value: 'nizn', label: 'Nickel Zinc' },
    { value: 'lead-acid', label: 'Lead Acid' },
    { value: 'flow', label: 'Flow' },
    { value: 'solid-state', label: 'Solid State' },
    { value: 'zinc-air', label: 'Zinc Air' },
    { value: 'sodium-ion', label: 'Sodium Ion' },
    { value: 'sodium-sulfur', label: 'Sodium Sulfur' },
    { value: 'lithium-sulfur', label: 'Lithium Sulfur' },
];

export const BatteryTechnologies = {
    validator: z.array(z.enum(batteryTechnologyValues)),
    options,
};

export type BatteryTechnologies = z.infer<typeof BatteryTechnologies.validator>;
